import { zxcvbnOptions } from "@zxcvbn-ts/core";
import { MatchEstimated, Matcher, Match } from "@zxcvbn-ts/core/dist/types";

const simplePasswordMatcher: Matcher = {
  Matching: class SimpleMatcher {
    simplePasswords = [
      "123456",
      "password",
      "123456789",
      "12345678",
      "12345",
      "1234567",
      "1234567890",
      "qwerty",
      "abc123",
      "111111",
      "secret",
      "testing"
    ];

    match({ password }: { password: string }) {
      const matches: Match[] = [];
      if (this.simplePasswords.includes(password.toLowerCase())) {
        matches.push({
          pattern: "simplePassword",
          token: password,
          i: 0,
          j: password.length - 1,
        });
      }

      return matches;
    }
  },
  feedback(match: MatchEstimated, isSoleMatch: boolean) {
    return {
      warning: "Your password is too simple",
      suggestions: [],
    };
  },
  scoring(match) {
    return 0;
  },
};
zxcvbnOptions.addMatcher("simplePassword", simplePasswordMatcher);
